import React, { useState } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { joinKeys } from 'helpers/translations.helper'
import { IExternalCourseParticipant } from 'models/externalCourseParticipant.model'
import { prefixTranslation } from './common'
import { DropdownLoader } from 'components/ui/DropdownLoader'
import { DropdownButton, styles } from 'components/ui/DropdownButton'

export interface OptionsEvents {
  onDelete(): void
  onDeleteCertificate(): void
  onDownloadCertificate(): void
}

interface OptionsProps extends OptionsEvents {
  participant: IExternalCourseParticipant
}

const Options: React.FC<OptionsProps> = ({
  participant,
  onDelete,
  onDeleteCertificate,
  onDownloadCertificate,
}) => {
  const { t } = useTranslation()
  const loading = false
  const [show, setShow] = useState(false)

  const handleDropdownClick = (show: boolean) => {
    setShow(show)
  }

  const certificate = participant?.certificate

  return (
    <>
      <DropdownButton
        show={show}
        id="dropdown-menu-align-right"
        className={styles.actionSelect}
        alignRight
        title={<DropdownLoader loading={loading} />}
        onClick={() => handleDropdownClick(!show)}
        onToggle={() => handleDropdownClick(!show)}
      >
        <a
          className={classNames(!certificate && styles.disabled)}
          onClick={() => {
            certificate && onDeleteCertificate()
          }}
        >
          {t(joinKeys(prefixTranslation, 'deleteCertificate'))}
        </a>
        <a onClick={() => onDelete()}>
          {t(joinKeys(prefixTranslation, 'delete'))}
        </a>
        <a
          className={classNames(!certificate && styles.disabled)}
          onClick={() => {
            certificate && onDownloadCertificate()
          }}
        >
          {t(joinKeys(prefixTranslation, 'downloadCertificate'))}
        </a>
      </DropdownButton>
    </>
  )
}

export default Options
